<template>
<div>
  <div v-for="(s, k) in combinedStepAndStates"
       :key="`validate-denominators-step-${k}`">
    <alert :type="alerts[s.state._state]" :class="classes[s.state._state]">
      <p>
        <span :class="`glyphicon glyphicon-${icons[s.state._state]}`"
              aria-hidden="true">
        </span>
        <strong>{{ s.step.title }}</strong>
      </p>
      <div v-if="s.state._state === states.running">
        <progress-bar striped min-width label active
          :value="s.step.progress ? s.step.progress.value : 0" />
      </div>
      <div v-else>
        <p v-if="s.state._report" v-html="s.state._report" class="text-justify"></p>

        <div v-if="s.state._state === states.pending">
          Voulez vous continuer ?
          <btn type="warning" @click="s.state.answer(false)">Non</btn>&nbsp;
          <btn type="success" @click="s.state.answer(true)">Oui</btn>
        </div>
        <div v-else-if="s.state._msg != null">
          <p v-html="s.state._msg" class="text-justify"></p>
        </div>
      </div>

    </alert>
  </div>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'

export default {
  name: 'validate-steps',
  props: {
    steps: {
      type: Array,
      required: true
    },
    stepStates: {
      type: Array,
      required: true
    }
  },

  data: function () {
    const states = StepIterator.states

    const alerts = [
      'info',
      'info',
      'success',
      'danger',
      'warning'
    ]

    const icons = [
      'unchecked',
      'edit',
      'check',
      'alert',
      'edit'
    ]

    const classes = [
      'transparent',
      '',
      '',
      '',
      ''
    ]

    return {
      states: states,
      alerts: alerts,
      icons: icons,
      classes: classes
    }
  },

  computed: {
    combinedStepAndStates: function () {
      const steps = this.steps
      const states = this.stepStates

      if (steps == null ||
          states == null ||
          steps.length !== states.length) {
        return null
      }

      const result = []
      for (let i = 0; i < steps.length; i++) {
        result.push({ step: steps[i], state: states[i] })
      }
      return result
    }
  }
}
</script>
<style lang="less" scoped>
.progress-bar {
    transition: width 0.030s;
}

.glyphicon {
    margin-right: 0.7rem;
}

.transparent {
    opacity: 0.3;
}
</style>
